import { formatDate, calcPeriod } from '../../utils';

function ExperienceDate({ startDate, endDate }) {
  const start = formatDate(startDate, 'short');
  const end = endDate ? formatDate(endDate, 'short') : 'Present';
  const period = calcPeriod(startDate, endDate);

  return (
    <div className="experience__date">
      <time dateTime={startDate}>{start}</time>
      {" — "}
      <time dateTime={endDate ?? ''}>{end}</time>
      {" "}({period})
    </div>
  );
}

export { ExperienceDate };
